if (!window.Eurus.loadedScript.has('locales-form.js')) {
  window.Eurus.loadedScript.add('locales-form.js');

  requestAnimationFrame(() => {
    document.addEventListener('alpine:init', () => {
      Alpine.data('xLocalizationForm', () => ({ 
        openCountry: false,
        loading: false,
        cachedResults: false,
        submit(value, input) {
          const form = this.$el.closest('form');
          form.querySelector('#' + input).value = value;
          if (input === 'currency_selector' && !['DE', 'AT', 'CH', 'LI'].includes(value)) {
            let locale = form.querySelector('[name="locale_code"]');
            if (!locale) {
              locale = document.createElement('input');
              locale.type = 'hidden';
              locale.name = 'locale_code';
              form.appendChild(locale);
            }
            locale.value = 'en';
          }
          form.submit();
        },
        loadCountry(el) {
          if (this.cachedResults) {
            this.openCountry = true;
            return true
          }
          let countrySelector = el.closest(".country-selector");
          let optionEL = countrySelector.querySelector(".country-options");

          this.loading = true;
          fetch(window.Shopify.routes.root + '?section_id=country-selector')
          .then(reponse => {
            return reponse.text();
          })
          .then((response) => {
            const parser = new DOMParser();
            const content = parser.parseFromString(response,'text/html').getElementById("list-country").innerHTML;
            optionEL.innerHTML = content;
            this.cachedResults = true;
            this.openCountry = true;
          })
          .finally(() => {
            this.loading = false;
          })
        },
      }))
    });
  });
}